import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { setDeleteLoading } from "../../menu/menuSlice";
import {
  errorAlertHandle,
  successAlertHandle,
} from "../../../../utils/utilFunctions";

// countries
export const getCountry = createAsyncThunk(
  "location/getCountry",
  async (id) => {
    const res = await axios.get(`/api/loc/country?id=${id}`);
    return res.data;
  }
);

export const getCountries = createAsyncThunk(
  "location/getCountries",
  async ({ start, limit, filters }) => {
    const config = { headers: { "Content-Type": "application/json" } };
    const body = JSON.stringify({ ...filters });
    const res = await axios.post(
      `/api/loc/country/filter?start=${start}&limit=${limit}`,
      body,
      config
    );
    return res.data;
  }
);

export const addCountry = createAsyncThunk(
  "location/addCountry",
  async (data, { dispatch, rejectWithValue }) => {
    try {
      const { location } = data;
      const config = { headers: { "Content-Type": "application/json" } };
      const body = JSON.stringify({ name: location });
      const res = await axios.post("api/loc/country", body, config);
      successAlertHandle("Country added successfully!", dispatch);
      return res.data;
    } catch (err) {
      errorAlertHandle(err, dispatch);
      return rejectWithValue(err.response.data.error);
    }
  }
);

export const updateCountry = createAsyncThunk(
  "location/updateCountry",
  async (data, { dispatch, rejectWithValue }) => {
    try {
      const config = { headers: { "Content-Type": "application/json" } };
      const body = JSON.stringify(data);
      const res = await axios.put("api/loc/country", body, config);
      successAlertHandle("Country updated successfully!", dispatch);
      return res.data;
    } catch (err) {
      errorAlertHandle(err, dispatch);
      return rejectWithValue(err.response.data.error);
    }
  }
);

export const deleteCountry = createAsyncThunk(
  "location/deleteCountry",
  async (id, { dispatch, rejectWithValue }) => {
    dispatch(setDeleteLoading(true));
    try {
      const res = await axios.delete(`/api/loc/country?id=${id}`);
      successAlertHandle("Country deleted successfully!", dispatch);
      dispatch(setDeleteLoading(false));
      return res.data;
    } catch (err) {
      dispatch(setDeleteLoading(false));
      errorAlertHandle(err, dispatch);
      return rejectWithValue(err.response.data.error);
    }
  }
);

// states
export const getStates = createAsyncThunk(
  "location/getStates",
  async ({ start, limit, filters }) => {
    const config = { headers: { "Content-Type": "application/json" } };
    const body = JSON.stringify({ ...filters });
    const res = await axios.post(
      `/api/loc/state/filter?start=${start}&limit=${limit}`,
      body,
      config
    );
    return res.data;
  }
);

export const addState = createAsyncThunk(
  "location/addState",
  async (data, { dispatch, rejectWithValue }) => {
    try {
      const { location, parent } = data;
      const config = { headers: { "Content-Type": "application/json" } };
      const body = JSON.stringify({ name: location, country: parent });
      const res = await axios.post("api/loc/state", body, config);
      successAlertHandle("Province added successfully!", dispatch);
      return res.data;
    } catch (err) {
      errorAlertHandle(err, dispatch);
      return rejectWithValue(err.response.data.error);
    }
  }
);

export const updateState = createAsyncThunk(
  "location/updateState",
  async (data, { dispatch, rejectWithValue }) => {
    try {
      const config = { headers: { "Content-Type": "application/json" } };
      const body = JSON.stringify(data);
      const res = await axios.put("api/loc/state", body, config);
      successAlertHandle("Province updated successfully!", dispatch);
      return res.data;
    } catch (err) {
      errorAlertHandle(err, dispatch);
      return rejectWithValue(err.response.data.error);
    }
  }
);

export const deleteState = createAsyncThunk(
  "location/deleteState",
  async (id, { dispatch, rejectWithValue }) => {
    dispatch(setDeleteLoading(true));
    try {
      const res = await axios.delete(`/api/loc/state?id=${id}`);
      successAlertHandle("Province deleted successfully!", dispatch);
      dispatch(setDeleteLoading(false));
      return res.data;
    } catch (err) {
      dispatch(setDeleteLoading(false));
      errorAlertHandle(err, dispatch);
      return rejectWithValue(err.response.data.error);
    }
  }
);

// districts
export const getDistricts = createAsyncThunk(
  "location/getDistricts",
  async ({ start, limit, filters }) => {
    const config = { headers: { "Content-Type": "application/json" } };
    const body = JSON.stringify({ ...filters });
    const res = await axios.post(
      `/api/loc/district/filter?start=${start}&limit=${limit}`,
      body,
      config
    );
    return res.data;
  }
);

export const addDistrict = createAsyncThunk(
  "location/addDistrict",
  async (data, { dispatch, rejectWithValue }) => {
    try {
      const { location, parent } = data;
      const config = { headers: { "Content-Type": "application/json" } };
      const body = JSON.stringify({ name: location, state: parent });
      const res = await axios.post("api/loc/district", body, config);
      successAlertHandle("District added successfully!", dispatch);
      return res.data;
    } catch (err) {
      errorAlertHandle(err, dispatch);
      return rejectWithValue(err.response.data.error);
    }
  }
);

export const updateDistrict = createAsyncThunk(
  "location/updateDistrict",
  async (data, { dispatch, rejectWithValue }) => {
    try {
      const config = { headers: { "Content-Type": "application/json" } };
      const body = JSON.stringify(data);
      const res = await axios.put("api/loc/district", body, config);
      successAlertHandle("District updated successfully!", dispatch);
      return res.data;
    } catch (err) {
      errorAlertHandle(err, dispatch);
      return rejectWithValue(err.response.data.error);
    }
  }
);

export const deleteDistrict = createAsyncThunk(
  "location/deleteDistrict",
  async (id, { dispatch, rejectWithValue }) => {
    dispatch(setDeleteLoading(true));
    try {
      const res = await axios.delete(`/api/loc/district?id=${id}`);
      successAlertHandle("District deleted successfully!", dispatch);
      dispatch(setDeleteLoading(false));
      return res.data;
    } catch (err) {
      dispatch(setDeleteLoading(false));
      errorAlertHandle(err, dispatch);
      return rejectWithValue(err.response.data.error);
    }
  }
);

// cities
export const getCities = createAsyncThunk(
  "location/getCities",
  async ({ start, limit, filters }) => {
    const config = { headers: { "Content-Type": "application/json" } };
    const body = JSON.stringify({ ...filters });
    const res = await axios.post(
      `/api/loc/city/filter?start=${start}&limit=${limit}`,
      body,
      config
    );
    return res.data;
  }
);

export const addCity = createAsyncThunk(
  "location/addCity",
  async (data, { dispatch, rejectWithValue }) => {
    try {
      const { location, parent } = data;
      const config = { headers: { "Content-Type": "application/json" } };
      const body = JSON.stringify({ name: location, district: parent });
      const res = await axios.post("api/loc/city", body, config);
      successAlertHandle("City added successfully!", dispatch);
      return res.data;
    } catch (err) {
      errorAlertHandle(err, dispatch);
      return rejectWithValue(err.response.data.error);
    }
  }
);

export const updateCity = createAsyncThunk(
  "location/updateCity",
  async (data, { dispatch, rejectWithValue }) => {
    try {
      const config = { headers: { "Content-Type": "application/json" } };
      const body = JSON.stringify(data);
      const res = await axios.put("api/loc/city", body, config);
      successAlertHandle("City updated successfully!", dispatch);
      return res.data;
    } catch (err) {
      errorAlertHandle(err, dispatch);
      return rejectWithValue(err.response.data.error);
    }
  }
);

export const deleteCity = createAsyncThunk(
  "location/deleteCity",
  async (id, { dispatch, rejectWithValue }) => {
    dispatch(setDeleteLoading(true));
    try {
      const res = await axios.delete(`/api/loc/city?id=${id}`);
      successAlertHandle("City deleted successfully!", dispatch);
      dispatch(setDeleteLoading(false));
      return res.data;
    } catch (err) {
      dispatch(setDeleteLoading(false));
      errorAlertHandle(err, dispatch);
      return rejectWithValue(err.response.data.error);
    }
  }
);

// hooks
export const getCountriesNoLimit = async () => {
  try {
    const config = { headers: { "Content-Type": "application/json" } };
    const body = JSON.stringify({});
    const res = await axios.post(`/api/loc/country/filter`, body, config);
    return res.data;
  } catch (error) {
    console.log(error.message);
  }
};

export const getStatesNoLimit = async () => {
  try {
    const config = { headers: { "Content-Type": "application/json" } };
    const body = JSON.stringify({});
    const res = await axios.post(`/api/loc/state/filter`, body, config);
    return res.data;
  } catch (error) {
    console.log(error.message);
  }
};

export const getDistrictsNoLimit = async () => {
  try {
    const config = { headers: { "Content-Type": "application/json" } };
    const body = JSON.stringify({});
    const res = await axios.post(`/api/loc/district/filter`, body, config);
    return res.data;
  } catch (error) {
    console.log(error.message);
  }
};

export const getCitiesNoLimit = async () => {
  try {
    const config = { headers: { "Content-Type": "application/json" } };
    const body = JSON.stringify({});
    const res = await axios.post(`/api/loc/city/filter`, body, config);
    return res.data;
  } catch (error) {
    console.log(error.message);
  }
};

export const getWarehousesNoLimit = async () => {
  try {
    const config = { headers: { "Content-Type": "application/json" } };
    const body = JSON.stringify({});
    const res = await axios.post(`/api/loc/warehouse/filter`, body, config);
    return res.data;
  } catch (error) {
    console.log(error.message);
  }
};

export const getFarmerLocationMaster = async () => {
  try {
    const res = await axios.get(`/api/loc?type=farmer`);
    return res.data;
  } catch (error) {
    console.log(error.message);
  }
};

export const getUserLocationMaster = async () => {
  try {
    const res = await axios.get(`/api/loc?type=user`);
    return res.data;
  } catch (error) {
    console.log(error.message);
  }
};
